/**
 * @generated SignedSource<<7bcb1f8d763df443b38c4655f5a47d6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemSubTodoResponse_todo$data = {
  readonly response: {
    readonly __typename: "TodoResponseImage";
  } | {
    readonly __typename: "TodoResponseNumber";
  } | {
    readonly __typename: "TodoResponseText";
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainFooterResponseImage_todo" | "TodoEditNewMainFooterResponseNumber_todo" | "TodoEditNewMainFooterResponseText_todo">;
  readonly " $fragmentType": "TodoListItemSubTodoResponse_todo";
};
export type TodoListItemSubTodoResponse_todo$key = {
  readonly " $data"?: TodoListItemSubTodoResponse_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemSubTodoResponse_todo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemSubTodoResponse_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseImage_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseNumber_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainFooterResponseText_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseImage",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "TodoResponseText",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "ffda46c5157cf5a39f3bfd3e64eec56d";

export default node;
